export default __webpack_public_path__ + "static/media/1.44044d87.jpg";